import * as React from 'react'
import { Query } from 'react-apollo'

import { ILeadStatus, TargetType, UpcomingEvent, UpcomingEventType } from '../types'
import Content from './Content'
import ContentLoader from './ContentLoader'
import {
  SCHOOL_MAP_CALLOUT_QUERY,
  SchoolMapCallout,
  SchoolMapCallout_school,
  SchoolMapCalloutVariables,
} from './gql'

interface IProps {
  schoolId: number
  leadStatus?: ILeadStatus
}

export default function SchoolContent(props: IProps) {
  const { schoolId, leadStatus } = props

  return (
    <Query<SchoolMapCallout, SchoolMapCalloutVariables>
      query={SCHOOL_MAP_CALLOUT_QUERY}
      variables={{ schoolId }}
    >
      {({ loading, error, data }) => {
        if (loading || error || !data || !data.school) {
          return <ContentLoader />
        }

        const { school } = data

        return (
          <Content
            target={{
              _type: TargetType.School,
              school,
            }}
            leadStatus={leadStatus}
            upcomingEvent={upcomingEventForSchool(school)}
          />
        )
      }}
    </Query>
  )
}

function upcomingEventForSchool(school: SchoolMapCallout_school): UpcomingEvent | null {
  const { upcomingGatherings } = school
  const gathering = upcomingGatherings[0]
  if (!gathering) return null

  return {
    __type: UpcomingEventType.Gathering,
    gathering,
  }
}
